module.exports = __webpack_public_path__ + "img/2023-27.9f0581da.jpg";